// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2auug","title":"Info_title__12IJW","links":"Info_links__2iCVB","link":"Info_link__2LSR-","logo":"Info_logo__3p2nm"};